import { apiFetch } from '@/shared/api/apiClient';

interface DeleteResponse {
    ok?: boolean;
    deleted_count?: number;
    unread_count?: number;
}

export async function deleteNotification(id: string): Promise<DeleteResponse | null> {
    return apiFetch<DeleteResponse>(route('notifications.delete', { id }), {
        method: 'DELETE',
    });
}

export async function deleteAllReadNotifications(): Promise<DeleteResponse | null> {
    return apiFetch<DeleteResponse>(route('notifications.delete_read_all'), {
        method: 'DELETE',
    });
}
